import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConstsHelper } from '../../../../helpers/consts.helper';

@Component({
  selector: 'app-account-shipping-address',
  templateUrl: './account-shipping-address.component.html',
  styleUrls: ['./account-shipping-address.component.css'],
  standalone: false
})
export class AccountShippingAddressComponent implements OnInit {

  @Output()
  accountShippingAddress = new EventEmitter<any>();

  form: FormGroup;
  formSubmitted: boolean;
  errors: any = {
    shippingAddressLastName: {
      required: `Le nom est obligatoire.`,
      pattern: `Veuillez saisir un nom sans accent, caractères spéciaux ni chiffres.`
    },
    shippingAddressFirstName: {
      required: `Le prénom est obligatoire.`,
      pattern: `Veuillez saisir un nom sans accent, caractères spéciaux ni chiffres.`
    },
    address: {
      required: `L'adresse est obligatoire.`,
      pattern: `Veuillez saisir une adresse avec au moins deux caractères et sans utiliser de caractères spéciaux ni accent.`
    },
    zipCode: {
      required: `Le code postal est obligatoire.`,
      pattern: `Le code postal saisie n'est pas valide.`
    },
    city: {
      required: `La ville est obligatoire.`,
      pattern: `Veuillez saisir un nom de ville sans accent, caractères spéciaux ni chiffres.`
    },
    addressComplement: {
      pattern:
          `Veuillez saisir un complément d\'adresse avec au moins deux caractères et sans utiliser de caractères spéciaux ni accent.`
    },
  };

  constructor(
      private formBuilder: FormBuilder,
  ) {}

  ngOnInit() {
    this.formSubmitted = false;
    this.initForm();
  }

  initForm() {
    this.form = this.formBuilder.group({});
    this.form = new FormGroup({
      shippingAddressCivility: new FormControl('Mr', Validators.required),
      shippingAddressLastName: new FormControl('', [Validators.required, Validators.pattern(ConstsHelper.lastNamePattern)]),
      shippingAddressFirstName: new FormControl('', [Validators.required, Validators.pattern(ConstsHelper.firstNamePattern)]),
      address: new FormControl('', [Validators.required, Validators.pattern(ConstsHelper.addressPattern)]),
      zipCode: new FormControl('', [Validators.required, Validators.pattern(ConstsHelper.zipCodePattern)]),
      city: new FormControl('', [Validators.required, Validators.pattern(ConstsHelper.cityPattern)]),
      addressComplement: new FormControl('', [Validators.pattern(ConstsHelper.addressPattern)]),
    });
  }

  submit() {
    this.formSubmitted = true;
    if (this.form.valid) {
      const accountShippingAddress = {
        shippingAddressCivility: this.form.get('shippingAddressCivility').value,
        shippingAddressLastName: this.form.get('shippingAddressLastName').value,
        shippingAddressFirstName: this.form.get('shippingAddressFirstName').value,
        address: this.form.get('address').value,
        zipCode: this.form.get('zipCode').value,
        city: this.form.get('city').value,
        addressComplement: this.form.get('addressComplement').value,
      };
      this.accountShippingAddress.emit(accountShippingAddress);
    }
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.form.controls[formControlName].invalid) {
      Object.keys(this.form.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }
}
